<script type="text/ecmascript-6">
    import MainSidebar from './MainSidebar.vue'
    import MainNavbar from './MainNavbar.vue'
    import MainFooter from "./MainFooter";
    import Loading from "../components/Loading";

    export default {
        components: {Loading, MainFooter, MainNavbar, MainSidebar }
    }
</script>

<template>
    <div id="wrapper">

        <!-- Sidebar -->
        <main-sidebar/>
        <!-- End of Sidebar -->

        <!-- Content Wrapper -->
        <div id="content-wrapper" class="d-flex flex-column">

            <!-- Main Content -->
            <div id="content">

                <!-- Topbar -->
                <main-navbar/>
                <!-- End of Topbar -->

                <loading></loading>

                <!-- Begin Page Content -->
                    <slot/>
                <!-- /.container-fluid -->

            </div>
            <!-- End of Main Content -->

            <!-- Footer -->
            <main-footer/>
            <!-- End of Footer -->

        </div>
        <!-- End of Content Wrapper -->

    </div>
</template>

